import UICardGrid from 'UIComponents/card/UICardGrid';
import { View } from 'foundations-components/components/View';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { Fragment, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useAppContext } from '../../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_COLLECTIONS_PER_PAGE = 24;
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "AppCollectionsSection__StyledRouterLink",
  componentId: "sc-1x3riga-0"
})(["display:flex;align-items:stretch;"]);
export default function AppCollectionsSection({
  trackInteraction
}) {
  const {
    columns
  } = useResponsiveProps({
    columns: {
      sm: 1,
      md: 2,
      lg: 3
    }
  });
  const {
    paddingBlockEnd,
    paddingInline
  } = useResponsiveProps({
    paddingBlockEnd: {
      md: undefined,
      lg: '1000'
    },
    paddingInline: {
      md: undefined,
      lg: '500'
    }
  });
  const {
    marginInline
  } = useResponsiveProps({
    marginInline: {
      md: undefined,
      lg: '1300'
    }
  });
  const appContext = useAppContext();
  const {
    getDisplayedCollections,
    requestState: publishedAppCollectionsRequestState
  } = usePublishedCollections({
    appContext: appContext,
    offeringType: 'APP'
  });
  const displayedCollections = getDisplayedCollections();
  const [page, setPage] = useState(1);
  const offset = useMemo(() => (page - 1) * MAX_COLLECTIONS_PER_PAGE, [page]);
  const limit = useMemo(() => displayedCollections.length && displayedCollections.length <= MAX_COLLECTIONS_PER_PAGE * page ? displayedCollections.length : offset + MAX_COLLECTIONS_PER_PAGE, [displayedCollections, offset, page]);
  const pageCount = Math.ceil(displayedCollections.length / MAX_COLLECTIONS_PER_PAGE);
  const needsPagination = pageCount > 1;
  const currentCollections = useMemo(() => {
    return displayedCollections.slice(offset, limit);
  }, [displayedCollections, offset, limit]);
  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
    trackInteraction('change collections page', {
      pageNumber: newPage
    });
  }, [trackInteraction]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: publishedAppCollectionsRequestState,
    children: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginInline: marginInline,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        children: /*#__PURE__*/_jsx(UICardGrid, {
          columns: columns,
          children: currentCollections.map(collection => {
            const publishedListing = collection.publishedListing;
            if (!publishedListing) {
              return null;
            }
            return /*#__PURE__*/_jsx(StyledRouterLink, {
              onClick: () => trackInteraction('click collection', {
                value: publishedListing.slug,
                pageNumber: page
              }),
              to: `/${publishedListing.slug}`,
              use: "unstyled",
              children: /*#__PURE__*/_jsx(CollectionCard, {
                collection: collection
              })
            }, `collection-${collection.id}`);
          })
        })
      }), needsPagination && /*#__PURE__*/_jsx(Paginator, {
        onPageChange: ({
          target: {
            value
          }
        }) => handlePageChange(value),
        pageCount: pageCount
      })]
    })
  });
}